import styled from 'styled-components';
import { FaFacebookF, FaPinterestP, FaInstagram, FaTwitter, FaMediumM, FaShoppingCart } from 'react-icons/fa';
var buttonAttrs = {
  color: '#f7f7f7',
  size: 'calc(50%)'
};
var Facebook = styled(FaFacebookF).attrs(buttonAttrs).withConfig({
  displayName: "SocialPageButtonstyles__Facebook",
  componentId: "pantheon__cbck7v-0"
})([""]);
var Pinterest = styled(FaPinterestP).attrs(buttonAttrs).withConfig({
  displayName: "SocialPageButtonstyles__Pinterest",
  componentId: "pantheon__cbck7v-1"
})([""]);
var Instagram = styled(FaInstagram).attrs(buttonAttrs).withConfig({
  displayName: "SocialPageButtonstyles__Instagram",
  componentId: "pantheon__cbck7v-2"
})([""]);
var Twitter = styled(FaTwitter).attrs(buttonAttrs).withConfig({
  displayName: "SocialPageButtonstyles__Twitter",
  componentId: "pantheon__cbck7v-3"
})([""]);
var Medium = styled(FaMediumM).attrs(buttonAttrs).withConfig({
  displayName: "SocialPageButtonstyles__Medium",
  componentId: "pantheon__cbck7v-4"
})([""]);
var Shop = styled(FaShoppingCart).attrs(buttonAttrs).withConfig({
  displayName: "SocialPageButtonstyles__Shop",
  componentId: "pantheon__cbck7v-5"
})([""]);
var InlineButtons = styled.div.withConfig({
  displayName: "SocialPageButtonstyles__InlineButtons",
  componentId: "pantheon__cbck7v-6"
})(["display:inline-flex;"]);
export { Facebook, Pinterest, Instagram, Twitter, Medium, Shop, InlineButtons };